import { useHasPermission } from '../plugs/current-user';

export interface ClientPermissions {
  canView: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export function useClientPermissions(): ClientPermissions {
  const canView = useHasPermission('client.view');
  const canCreate = useHasPermission('client.create');
  const canUpdate = useHasPermission('client.update');
  const canDelete = useHasPermission('client.delete');

  return { canView, canCreate, canUpdate, canDelete };
}
